import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Customer } from './types';

export type UpdateCustomerResponse = Customer;
type Variables = {
  firstName?: string;
  lastName?: string;
  dob?: Date;
  email?: string;
  smsOptIn?: boolean;
};

export const useUpdateCustomer = createMutation<
  UpdateCustomerResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ firstName, lastName, dob, email, smsOptIn }) =>
    client({
      url: 'v2/customers/me',
      method: 'PUT',
      data: {
        firstname: firstName,
        lastname: lastName,
        dob,
        email,
        is_sms_opted_in: smsOptIn,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
